"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.retryRequest = void 0;
const auth_1 = __importStar(require("@themenu/auth"));
const request_1 = require("./request");
const refreshToken = async () => {
    try {
        await auth_1.default.exchangeToken({
            grant_type: 'refresh_token',
            refresh_token: auth_1.default.rt,
        });
    }
    catch {
        //no use of the error
    }
};
const retryRequest = async ({ method, endpoint, serviceUrl, body = undefined, headers = {}, options = { encode: false, rawRequest: false, rawResponse: false, withStatusCode: false }, }) => {
    const url = `${serviceUrl}/${endpoint}`;
    const params = {
        method,
        endpoint,
        serviceUrl,
        body,
        headers,
        options,
    };
    let response;
    try {
        response = await (0, request_1.request)(params);
    }
    catch (error) {
        const responseError = error;
        if (responseError.status === 401 && !url.includes(auth_1.REFRESH_TOKEN_PATH) && auth_1.default.rt) {
            await refreshToken();
            response = await (0, request_1.request)(params);
        }
        else {
            throw responseError;
        }
    }
    return response;
};
exports.retryRequest = retryRequest;
//# sourceMappingURL=retryRequest.js.map